import styled from 'styled-components';
import {
  ItemIndicator,
  ScrollUpButton,
  ScrollDownButton,
} from '@radix-ui/react-select';

export const SelectItemIndicator = styled(ItemIndicator)`
  position: absolute;
  left: 12px;
  width: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--way-palette-black-60);
`;

export const SelectScrollUpButton = styled(ScrollUpButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  background-color: var(--way-palette-white-100);
  color: var(--way-colors-svgColor);
  cursor: default;
`;

export const SelectScrollDownButton = styled(ScrollDownButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  background-color: var(--way-palette-white-100);
  color: var(--way-colors-svgColor);
  cursor: default;
`;

export const MultiValueChip = styled.span`
  background-color: var(--way-palette-black-10);
  color: var(--way-colors-calendarInputColor);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0;
  margin-left: 4px;
  font-size: 12px;
  line-height: 1;

  &:hover {
    opacity: 0.7;
  }
`;
